"use client";

import { c as _c } from "react/compiler-runtime";
import { locales } from "@/i18n";
import { clsx } from "clsx";
import { Globe, Menu, X } from "lucide-react";
import { useLocale, useTranslations } from "next-intl";
import { usePathname, useRouter } from "next/navigation";
import { useEffect, useState } from "react";
export function Header() {
  const $ = _c(120);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isLangMenuOpen, setIsLangMenuOpen] = useState(false);
  const t = useTranslations("header");
  const locale = useLocale();
  const router = useRouter();
  const pathname = usePathname();
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const handleScroll = () => {
        setIsScrolled(window.scrollY > 50);
      };
      window.addEventListener("scroll", handleScroll);
      return () => window.removeEventListener("scroll", handleScroll);
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  if ($[2] !== locale || $[3] !== pathname || $[4] !== router) {
    t2 = newLocale => {
      const pathWithoutLocale = pathname.replace(`/${locale}`, "");
      router.push(`/${newLocale}${pathWithoutLocale}`);
      setIsLangMenuOpen(false);
      setIsMobileMenuOpen(false);
    };
    $[2] = locale;
    $[3] = pathname;
    $[4] = router;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const changeLocale = t2;
  const getLanguageLabel = _temp;
  const getLanguageName = _temp2;
  const t3 = isScrolled ? "bg-white-cream/95 backdrop-blur-md shadow-lg py-3" : "bg-transparent py-6";
  let t4;
  if ($[6] !== t3) {
    t4 = clsx("fixed top-0 left-0 right-0 z-50 transition-all duration-500", t3);
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = `/${locale}#`;
  const t6 = isScrolled ? "text-forest-green" : "text-forest-green";
  let t7;
  if ($[8] !== t6) {
    t7 = clsx("text-2xl font-bold font-serif transition-colors duration-300 hover:text-terracotta cursor-pointer", t6);
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t) {
    t8 = t("companyName");
    $[10] = t;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t5 || $[13] !== t7 || $[14] !== t8) {
    t9 = <div className="flex items-center gap-2"><a href={t5} className={t7} onClick={_temp3}>{t8}</a></div>;
    $[12] = t5;
    $[13] = t7;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  const t10 = `/${locale}#equipe`;
  let t11;
  if ($[16] !== t) {
    t11 = t("nav.team");
    $[16] = t;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== t10 || $[19] !== t11) {
    t12 = <a href={t10} className="text-charcoal hover:text-terracotta transition-colors">{t11}</a>;
    $[18] = t10;
    $[19] = t11;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  const t13 = `/${locale}#prestations`;
  let t14;
  if ($[21] !== t) {
    t14 = t("nav.services");
    $[21] = t;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] !== t13 || $[24] !== t14) {
    t15 = <a href={t13} className="text-charcoal hover:text-terracotta transition-colors">{t14}</a>;
    $[23] = t13;
    $[24] = t14;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  const t16 = `/${locale}#realisations`;
  let t17;
  if ($[26] !== t) {
    t17 = t("nav.projects");
    $[26] = t;
    $[27] = t17;
  } else {
    t17 = $[27];
  }
  let t18;
  if ($[28] !== t16 || $[29] !== t17) {
    t18 = <a href={t16} className="text-charcoal hover:text-terracotta transition-colors">{t17}</a>;
    $[28] = t16;
    $[29] = t17;
    $[30] = t18;
  } else {
    t18 = $[30];
  }
  const t19 = `/${locale}#contact`;
  let t20;
  if ($[31] !== t) {
    t20 = t("nav.contact");
    $[31] = t;
    $[32] = t20;
  } else {
    t20 = $[32];
  }
  let t21;
  if ($[33] !== t19 || $[34] !== t20) {
    t21 = <a href={t19} className="btn-primary">{t20}</a>;
    $[33] = t19;
    $[34] = t20;
    $[35] = t21;
  } else {
    t21 = $[35];
  }
  let t22;
  if ($[36] !== isLangMenuOpen) {
    t22 = () => setIsLangMenuOpen(!isLangMenuOpen);
    $[36] = isLangMenuOpen;
    $[37] = t22;
  } else {
    t22 = $[37];
  }
  let t23;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <Globe size={20} />;
    $[38] = t23;
  } else {
    t23 = $[38];
  }
  let t24;
  if ($[39] !== locale) {
    t24 = getLanguageLabel(locale);
    $[39] = locale;
    $[40] = t24;
  } else {
    t24 = $[40];
  }
  let t25;
  if ($[41] !== t24) {
    t25 = <span className="font-medium">{t24}</span>;
    $[41] = t24;
    $[42] = t25;
  } else {
    t25 = $[42];
  }
  let t26;
  if ($[43] !== t22 || $[44] !== t25) {
    t26 = <button onClick={t22} className="flex items-center gap-2 text-charcoal hover:text-terracotta transition-colors" aria-label="Changer de langue">{t23}{t25}</button>;
    $[43] = t22;
    $[44] = t25;
    $[45] = t26;
  } else {
    t26 = $[45];
  }
  let t27;
  if ($[46] !== changeLocale || $[47] !== isLangMenuOpen || $[48] !== locale) {
    t27 = isLangMenuOpen && <div className="absolute top-full right-0 mt-2 bg-white-cream rounded-lg shadow-xl border border-forest-green/10 overflow-hidden min-w-[140px]">{locales.map(loc_1 => <button key={loc_1} onClick={() => changeLocale(loc_1)} className={clsx("w-full px-4 py-2 text-left hover:bg-terracotta/10 transition-colors", locale === loc_1 && "bg-terracotta/20 font-semibold")}>{getLanguageName(loc_1)}</button>)}</div>;
    $[46] = changeLocale;
    $[47] = isLangMenuOpen;
    $[48] = locale;
    $[49] = t27;
  } else {
    t27 = $[49];
  }
  let t28;
  if ($[50] !== t26 || $[51] !== t27) {
    t28 = <div className="relative">{t26}{t27}</div>;
    $[50] = t26;
    $[51] = t27;
    $[52] = t28;
  } else {
    t28 = $[52];
  }
  let t29;
  if ($[53] !== t12 || $[54] !== t15 || $[55] !== t18 || $[56] !== t21 || $[57] !== t28) {
    t29 = <nav className="hidden md:flex items-center gap-8">{t12}{t15}{t18}{t21}{t28}</nav>;
    $[53] = t12;
    $[54] = t15;
    $[55] = t18;
    $[56] = t21;
    $[57] = t28;
    $[58] = t29;
  } else {
    t29 = $[58];
  }
  let t30;
  if ($[59] !== isMobileMenuOpen) {
    t30 = () => setIsMobileMenuOpen(!isMobileMenuOpen);
    $[59] = isMobileMenuOpen;
    $[60] = t30;
  } else {
    t30 = $[60];
  }
  let t31;
  if ($[61] !== isMobileMenuOpen || $[62] !== t) {
    t31 = isMobileMenuOpen ? t("mobileMenu.close") : t("mobileMenu.open");
    $[61] = isMobileMenuOpen;
    $[62] = t;
    $[63] = t31;
  } else {
    t31 = $[63];
  }
  let t32;
  if ($[64] !== isMobileMenuOpen) {
    t32 = isMobileMenuOpen ? <X size={28} /> : <Menu size={28} />;
    $[64] = isMobileMenuOpen;
    $[65] = t32;
  } else {
    t32 = $[65];
  }
  let t33;
  if ($[66] !== isMobileMenuOpen || $[67] !== t30 || $[68] !== t31 || $[69] !== t32) {
    t33 = <button className="md:hidden text-forest-green" onClick={t30} aria-label={t31} aria-expanded={isMobileMenuOpen}>{t32}</button>;
    $[66] = isMobileMenuOpen;
    $[67] = t30;
    $[68] = t31;
    $[69] = t32;
    $[70] = t33;
  } else {
    t33 = $[70];
  }
  let t34;
  if ($[71] !== t29 || $[72] !== t33 || $[73] !== t9) {
    t34 = <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">{t9}{t29}{t33}</div>;
    $[71] = t29;
    $[72] = t33;
    $[73] = t9;
    $[74] = t34;
  } else {
    t34 = $[74];
  }
  const t35 = isMobileMenuOpen ? "max-h-[calc(100vh-4rem)] opacity-100 pointer-events-auto overflow-y-auto" : "max-h-0 opacity-0 pointer-events-none overflow-hidden";
  let t36;
  if ($[75] !== t35) {
    t36 = clsx("md:hidden absolute top-full left-0 right-0 bg-white-cream shadow-xl transition-all duration-300", t35);
    $[75] = t35;
    $[76] = t36;
  } else {
    t36 = $[76];
  }
  const t37 = `/${locale}#equipe`;
  let t38;
  if ($[77] === Symbol.for("react.memo_cache_sentinel")) {
    t38 = () => setIsMobileMenuOpen(false);
    $[77] = t38;
  } else {
    t38 = $[77];
  }
  let t39;
  if ($[78] !== t) {
    t39 = t("nav.team");
    $[78] = t;
    $[79] = t39;
  } else {
    t39 = $[79];
  }
  let t40;
  if ($[80] !== t37 || $[81] !== t39) {
    t40 = <a href={t37} className="text-charcoal hover:text-terracotta transition-colors py-2" onClick={t38}>{t39}</a>;
    $[80] = t37;
    $[81] = t39;
    $[82] = t40;
  } else {
    t40 = $[82];
  }
  const t41 = `/${locale}#prestations`;
  let t42;
  if ($[83] === Symbol.for("react.memo_cache_sentinel")) {
    t42 = () => setIsMobileMenuOpen(false);
    $[83] = t42;
  } else {
    t42 = $[83];
  }
  let t43;
  if ($[84] !== t) {
    t43 = t("nav.services");
    $[84] = t;
    $[85] = t43;
  } else {
    t43 = $[85];
  }
  let t44;
  if ($[86] !== t41 || $[87] !== t43) {
    t44 = <a href={t41} className="text-charcoal hover:text-terracotta transition-colors py-2" onClick={t42}>{t43}</a>;
    $[86] = t41;
    $[87] = t43;
    $[88] = t44;
  } else {
    t44 = $[88];
  }
  const t45 = `/${locale}#realisations`;
  let t46;
  if ($[89] === Symbol.for("react.memo_cache_sentinel")) {
    t46 = () => setIsMobileMenuOpen(false);
    $[89] = t46;
  } else {
    t46 = $[89];
  }
  let t47;
  if ($[90] !== t) {
    t47 = t("nav.projects");
    $[90] = t;
    $[91] = t47;
  } else {
    t47 = $[91];
  }
  let t48;
  if ($[92] !== t45 || $[93] !== t47) {
    t48 = <a href={t45} className="text-charcoal hover:text-terracotta transition-colors py-2" onClick={t46}>{t47}</a>;
    $[92] = t45;
    $[93] = t47;
    $[94] = t48;
  } else {
    t48 = $[94];
  }
  const t49 = `/${locale}#contact`;
  let t50;
  if ($[95] === Symbol.for("react.memo_cache_sentinel")) {
    t50 = () => setIsMobileMenuOpen(false);
    $[95] = t50;
  } else {
    t50 = $[95];
  }
  let t51;
  if ($[96] !== t) {
    t51 = t("nav.contact");
    $[96] = t;
    $[97] = t51;
  } else {
    t51 = $[97];
  }
  let t52;
  if ($[98] !== t49 || $[99] !== t51) {
    t52 = <a href={t49} className="btn-primary text-center mt-2" onClick={t50}>{t51}</a>;
    $[98] = t49;
    $[99] = t51;
    $[100] = t52;
  } else {
    t52 = $[100];
  }
  let t53;
  if ($[101] === Symbol.for("react.memo_cache_sentinel")) {
    t53 = <p className="text-xs text-wood-natural mb-2 uppercase tracking-wider">Langue / Idioma / Hizkuntza</p>;
    $[101] = t53;
  } else {
    t53 = $[101];
  }
  let t54;
  if ($[102] !== changeLocale || $[103] !== locale) {
    t54 = locales.map(loc_2 => <button key={loc_2} onClick={() => changeLocale(loc_2)} className={clsx("px-4 py-2 rounded-lg text-left transition-colors", locale === loc_2 ? "bg-terracotta text-white-cream font-semibold" : "bg-sand-light text-charcoal hover:bg-terracotta/10")}>{getLanguageName(loc_2)}</button>);
    $[102] = changeLocale;
    $[103] = locale;
    $[104] = t54;
  } else {
    t54 = $[104];
  }
  let t55;
  if ($[105] !== t54) {
    t55 = <div className="border-t border-forest-green/10 pt-4 mt-2">{t53}<div className="flex flex-col gap-2">{t54}</div></div>;
    $[105] = t54;
    $[106] = t55;
  } else {
    t55 = $[106];
  }
  let t56;
  if ($[107] !== t40 || $[108] !== t44 || $[109] !== t48 || $[110] !== t52 || $[111] !== t55) {
    t56 = <nav className="flex flex-col p-6 gap-4">{t40}{t44}{t48}{t52}{t55}</nav>;
    $[107] = t40;
    $[108] = t44;
    $[109] = t48;
    $[110] = t52;
    $[111] = t55;
    $[112] = t56;
  } else {
    t56 = $[112];
  }
  let t57;
  if ($[113] !== t36 || $[114] !== t56) {
    t57 = <div className={t36}>{t56}</div>;
    $[113] = t36;
    $[114] = t56;
    $[115] = t57;
  } else {
    t57 = $[115];
  }
  let t58;
  if ($[116] !== t34 || $[117] !== t4 || $[118] !== t57) {
    t58 = <header className={t4}>{t34}{t57}</header>;
    $[116] = t34;
    $[117] = t4;
    $[118] = t57;
    $[119] = t58;
  } else {
    t58 = $[119];
  }
  return t58;
}
function _temp3(e) {
  e.preventDefault();
  window.scrollTo({
    top: 0,
    behavior: "smooth"
  });
}
function _temp2(loc_0) {
  switch (loc_0) {
    case "fr":
      {
        return "Fran\xE7ais";
      }
    case "es":
      {
        return "Espa\xF1ol";
      }
    case "eu":
      {
        return "Euskara";
      }
    default:
      {
        return loc_0;
      }
  }
}
function _temp(loc) {
  switch (loc) {
    case "fr":
      {
        return "FR";
      }
    case "es":
      {
        return "ES";
      }
    case "eu":
      {
        return "EU";
      }
    default:
      {
        return loc.toUpperCase();
      }
  }
}